import { ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

export function DetailsButton({ children, variant = "outline" }: { children: React.ReactNode; variant?: "outline" | "default" }) {
  return (
    <Button variant={variant} size='sm' className='px-[11.5px] py-[9.5px] text-xs font-normal text-(--gray-1) hover:cursor-pointer'>
      {children} <ChevronRight className='ml-1 w-3 h-3' />
    </Button>
  );
}
